import React, { memo } from 'react';
import Dialog from '@material-ui/core/Dialog';
import makeStyles from '@material-ui/core/styles/makeStyles';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Grid from '@material-ui/core/Grid';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { cloneDeep } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { setWatchlistCategories } from './../../reducers/Watchlist';
import PerfectScrollbar from 'react-perfect-scrollbar';
import CreateNewWatchlistCategory from './ManageWatchlist/CreateNewWatchlistCategory';

const AddToMultipleWatchlistDialog = ({ onClose, onAddToWatchlistClick }) => {
  const classes = useStyle();
  const dispatch = useDispatch();
  const watchlistCategories = useSelector(state => state.Watchlist.watchlistCategories);

  const handleCheckBoxChange = id => {
    const clickedCategoryIndex = watchlistCategories.findIndex(category => category.id === id);
    if (clickedCategoryIndex !== -1) {
      const copy = cloneDeep(watchlistCategories);
      copy[clickedCategoryIndex]['isCheckBoxChecked'] = !copy[clickedCategoryIndex]['isCheckBoxChecked'];
      dispatch(setWatchlistCategories(copy));
    }
  };

  const addToWatchlistHandler = () => {
    const selectedCategories = watchlistCategories
      .filter(c => c.isCheckBoxChecked)
      .map(c => c.id)
      .join(',');
    onAddToWatchlistClick(selectedCategories);
    onClose();
  };

  const isAnyCheckboxChecked = Boolean(watchlistCategories.find(categ => categ.isCheckBoxChecked));

  return (
    <Dialog open={true} onClose={onClose} fullWidth={true} maxWidth={'sm'} className={classes.dialogContainer}>
      <IconButton className={classes.closeButton} onClick={onClose}>
        <CloseIcon />
      </IconButton>
      <Grid container justify="center" alignItems="center" className={classes.dailogHeading} direction="column">
        Watchlist Labels
        <small>Add ticker in your favourite watchlist labels or create a new label. </small>
      </Grid>
      <Grid container justify="center">
        <Grid item container xs={11} className={classes.allCheckboxContainer}>
          {watchlistCategories?.length ? (
            <PerfectScrollbar style={{ width: '100%' }}>
              <Grid container>
                {watchlistCategories.map(category => (
                  <Grid key={category.id} item xs={12} sm={6} style={{ paddingLeft: '10px' }}>
                    <FormControlLabel
                      control={<Checkbox checked={category.isCheckBoxChecked ?? false} />}
                      label={category.name}
                      onChange={() => {
                        handleCheckBoxChange(category.id);
                      }}
                    />
                  </Grid>
                ))}
              </Grid>
            </PerfectScrollbar>
          ) : (
            <Grid container justify="center" alignItems="center" style={{ height: 'inherit' }}>
              <Typography variant="subtitle1">You don't have any watchlist label.</Typography>
            </Grid>
          )}
        </Grid>
      </Grid>
      <Grid className={classes.addNewWatchlistSection}>
        <CreateNewWatchlistCategory />
      </Grid>
      <Grid container alignItems="center" justify="center">
        <Grid container item xs={6} className={classes.addToWatchlistContainer}>
          <Button
            size="medium"
            fullWidth
            color="primary"
            variant="contained"
            disabled={!isAnyCheckboxChecked}
            onClick={addToWatchlistHandler}>
            Add to Watchlist
          </Button>
        </Grid>
      </Grid>
    </Dialog>
  );
};

const useStyle = makeStyles(theme => ({
  dailogHeading: {
    fontSize: '19px',
    fontWeight: 'bold',
    margin: '20px 0 10px 0',
  },
  allCheckboxContainer: {
    background: '#F6F6F6',
    maxHeight: '30vh',
    minHeight: '10vh',
    overflowY: 'auto',
    borderRadius: '10px',
    boxShadow: 'rgb(204, 219, 232) 3px 3px 6px 0px inset, rgba(255, 255, 255, 0.5) -3px -3px 6px 1px inset',
  },
  addNewWatchlistSection: {
    margin: '15px 30px',
  },
  addToWatchlistContainer: {
    marginTop: '10px',
    marginBottom: '20px',
  },
  closeButton: {
    position: 'absolute',
    zIndex: 1000,
    right: '-5px',
    top: '-5px',
    backgroundColor: theme.palette.primary.main,
    cursor: 'pointer',
    padding: 2,
    borderRadius: '50%',
    color: 'white',
    border: '1px solid #ccc',
    '&:hover': {
      background: theme.palette.primary.main,
    },
  },
  dialogContainer: {
    '& .MuiPaper-root': {
      overflowY: 'visible',
    },
  },
}));

export default memo(AddToMultipleWatchlistDialog);
